


























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Getter, Mutation, Action } from 'vuex-class';

@Component
export default class LayoutNav extends Vue {
    public name: string = 'LayoutNav';
    @Mutation('setUserInfo') setUserInfo!: any;
    @Mutation('setSsoUserId') setSsoUserId!: any;

    @Getter('userInfo') userInfo!: any;
    @Action('updateCsrf') updateCsrf!: any;

    @Prop({ default: '' }) public title!: string;
    @Prop({ default: '' }) public background!: string;
    @Prop({
        type: [Function],
        required: false,
    }) public goBack;

    // 导航展示和隐藏
    public show = false;

    // 是否嵌入到其他网站
    public isIframe = false;

    get showBackBtn() {
        if(/^\/users\//.test(this.$route.path)){
            return this.$route.path.split('/').length > 3;
        } else if(/^\/login|^\/register|^\/specials|^\/forget|^\/agreement/.test(this.$route.path)){
            return true
        } else if(/^\/special\//.test(this.$route.path)){
            return false
        } else{
            return this.$route.path.split('/').length > 2;
        }
    }

    // 是否展示关闭按钮
    get showClose(){
        return /^\/login|^\/register|^\/forget|^\/agreement/.test(this.$route.path)
    }

    get closeShadow(){
        return /^\/login|^\/register|^\/forget|^\/agreement|^\/activity\/.+\/rank|^\/$|^\/competitions$|^\/information$/.test(this.$route.path)
    }

    // 检查是否嵌入到其他网站
    checkIframe(){
        if (
            (self.frameElement && self.frameElement.tagName == "IFRAME") ||
            (window.frames.length != parent.frames.length) ||
            (self != top)
        ) {
            this.isIframe = true
        } else {
            this.isIframe = false
        }
    }

    // 跳转路由
    pushStack(routeName) {
        this.$router.push(routeName);
    }
    // 跳转至我的比赛
    onClickCompetition() {
        const id = this.userInfo.id;
        if (!id) {
            this.$router.push({ name: 'login', query: { source: this.$route.fullPath } });
            return;
        }
        this.$router.push(`/users/${id}`);
    }
    // 切换 至首页
    handlerJumpLogin() {
        this.$router.push({ name: 'login', query: { source: this.$route.fullPath } });
    }
    // 退出登录
    async handlerLogout() {
        const res = await this.$axios('userLoginOut');
        // await this.updateCsrf(res.headers['x-csrf-token']);
        this.setUserInfo({});
        this.setUserInfo(0);
        this.$toast('退出登录成功');
        if (this.$route.name === 'users') {
            this.$router.replace('/login');
        }
    }

    onClickLeft() {
        if(this.showBackBtn)
            this.goBack ? this.goBack() : this.$router.go(-1);
    }
    handleClose(){
        if(this.isIframe){
            this.$router.go(-1)
        }else{
            location.href = '/'
        }
    }

    mounted() {
        this.checkIframe()
    }
}
